import { PRESENCE_STATUS_ID, PRESENCE_STATUS_LABEL, VACATION_REQUEST_STATUS_LABELS } from "../../../configs/constants";
import moment from "moment";
export const get = (path, object, defaultValue = null) =>
  path.reduce((xs, x) => (xs && xs.hasOwnProperty(x) ? xs[x] : defaultValue), object);

export const isValidated = (halfday = {}) => {
  halfday = halfday || {};
  return halfday.validated;
};
export const isProcessed = (halfday = {}) => {
  halfday = halfday || {};
  return halfday.processed;
};
export const isHalfDayNotValidatedAcceptedVacation = (halfday = {}) => {
  const type = halfday.type || {};
  if (type.id !== PRESENCE_STATUS_ID.VACATION) return false;
  return !isValidated(halfday);
};

export const isHalfDayValidatedPresence = (halfday = {}) => {
  const type = halfday.type || {};
  if (type.id !== PRESENCE_STATUS_ID.ATTENDANCE) return false;
  return isValidated(halfday);
};

export const isHalfDayNotValidatedPresence = (halfday = {}) => {
  const type = halfday.type || {};
  if (type.id !== PRESENCE_STATUS_ID.ATTENDANCE) return false;
  return !isValidated(halfday);
};

export const isHalfDayAttendance = (halfday = {}) => {
  const type = halfday.type || {};
  return type.id === PRESENCE_STATUS_ID.ATTENDANCE;
};

export const isHalfDayAbsence = (halfday = {}) => {
  const type = halfday.type || {};
  return type.id === PRESENCE_STATUS_ID.ABSENCE;
};
export const isHalfDayNonWork = (halfday = {}) => {
  const type = halfday.type || {};
  return type.id === PRESENCE_STATUS_ID.NON_WORK;
};
export const isHalfDayVacation = (halfday = {}) => {
  const type = halfday.type || {};
  return type.id === PRESENCE_STATUS_ID.VACATION;
};

export const isHalfDayWithPendingVacation = (day = {}, period) => {
  const pending_vacations = day.pending_vacations || {};
  if (pending_vacations[period]) return true;
  return false;
};

const getPeriodDataOfDay = (day = {}, period) => {
  const attendances = day.attendances || {};
  const periodData = attendances[period] || {};
  return periodData;
};

export const computeTypeOfHalfDay = (day = {}, period) => {
  if (isHalfDayWithPendingVacation(day, period)) return VACATION_REQUEST_STATUS_LABELS.PENDING;
  const periodData = getPeriodDataOfDay(day, period);
  if (isHalfDayAttendance(periodData)) return PRESENCE_STATUS_LABEL.ATTENDANCE;
  else if (isHalfDayAbsence(periodData)) return PRESENCE_STATUS_LABEL.ABSENCE;
  else if (isHalfDayVacation(periodData)) return PRESENCE_STATUS_LABEL.VACATION;
  else if (isHalfDayNonWork(periodData)) return PRESENCE_STATUS_LABEL.NON_WORK;
};
export const isUnjustified = (day = {}, period) => {
  if (computeTypeOfHalfDay(day, period) !== PRESENCE_STATUS_LABEL.ABSENCE) return false;
  const periodData = getPeriodDataOfDay(day, period);
  const data = periodData.data || {};
  return data.id === "ANX";
};

export const computeTitleOfHalfDay = (day = {}, period) => {
  if (computeTypeOfHalfDay(day, period) === VACATION_REQUEST_STATUS_LABELS.PENDING) {
    const pending_vacations = day.pending_vacations || {};
    const pending_vacations_period = pending_vacations[period] || {};
    const typeVacation = pending_vacations_period.type || {};
    const labelVacation = typeVacation.label || "Congé N/C";
    return `Demande : ${labelVacation}`;
  } else if (computeTypeOfHalfDay(day, period) === PRESENCE_STATUS_LABEL.ATTENDANCE) {
    if (period === "afternoon") return "Présence après-midi";
    else return "Présence matin";
  } else if (computeTypeOfHalfDay(day, period) === PRESENCE_STATUS_LABEL.VACATION) {
    const periodData = getPeriodDataOfDay(day, period);
    const dataVacation = periodData.data || {};
    const typeVacation = dataVacation.type || {};
    const labelVacation = typeVacation.label || "Congé N/C";
    return labelVacation;
  } else if (computeTypeOfHalfDay(day, period) === PRESENCE_STATUS_LABEL.NON_WORK) {
    return PRESENCE_STATUS_LABEL.NON_WORK;
  } else if (computeTypeOfHalfDay(day, period) === PRESENCE_STATUS_LABEL.ABSENCE) {
    const periodData = getPeriodDataOfDay(day, period);
    const data = periodData.data || {};
    const label = data.label || "Absence N/C";
    return label;
  } else {
    return "N/C";
  }
};

export const computeEventInfos = (day = {}, period) => {
  // compute eventinfos for modal that validate vacation // TO Refacto
  const pending_vacations = day.pending_vacations || {};
  const request = pending_vacations[period] || {};
  return computeEventInfosFromRequest(request);
};

export const computeEventInfosFromRequest = (request = {}) => {
  const status = request && request.status ? request.status : {};
  const type = request && request.type ? request.type : {};
  const id = !!request ? request._id : -1;
  const attachments = request && Array.isArray(request.attachements) ? request.attachements : [];
  const duration =
    !!request && request.duration
      ? `${request.duration} jour(s) (du ${moment(request.start_date).format("llll")} au ${moment(
          request.end_date
        ).format("llll")})`
      : "N/C";
  const eventInfos = {
    type: status.id,
    visitType: status.label || "N/C",
    title: type.label,
    _id: id,
    duration,
    attachments
  };
  return eventInfos;
};



// WEBPACK FOOTER //
// src/modules/presence/utils/utils.js